import React from "react";
import { Button, Form, Image } from "react-bootstrap";
import BidUpload from "../pages/BidUpload";

const BidProgress: React.FC<{ status: number, isFileUploaded: boolean }> = ({ status, isFileUploaded }) => {
    return (
        <>
            <div className="bg-ass-demo rounded-12 p-4 mb-5">
                <div className="row">
                    <div className="col-lg-5 col-md-7 col-10 mx-auto py-3 mb-3">
                        <div className="bg-white text-center rounded-pill text-sm py-1 fw-300">
                            <Image className="height-25 mb-1 me-2" src="assets/images/other/icon-line-chart-red-ass.svg" />
                            現在の状況
                        </div>
                    </div>
                    {/* TODO: Look at PHP code */}
                    <div className="col-lg-11 col-12 mx-auto">
                        <div className="swiper-container">
                            <div className="swiper-wrapper timeline timeline-items-5">
                                <div className={`swiper-slide ${status === 0 ? "half-red" : "active"}`}>
                                    <div className="status left-border-off">
                                        <span className="timeline-text text-red-06">①応札条件入力</span>
                                    </div>
                                </div>
                                <div className={`swiper-slide ${status > 0 && isFileUploaded ? "active" : ''}`}>
                                    <div className={`status ${status === 1 && isFileUploaded ? '' : "right-border-ass"}`}>
                                        <span className={`timeline-text ${status > 0 && isFileUploaded ? "text-red-06" : ''}`}>
                                            ②見積書アップロード
                                        </span>
                                    </div>
                                </div>
                                <div className={`swiper-slide `}>
                                    <div className={`status `}>
                                        <span className={`timeline-text `}>
                                            ③面談希望日の提出
                                        </span>
                                    </div>
                                </div>
                                <div className={`swiper-slide `}>
                                    <div className={`status `}>
                                        <span className={`timeline-text `}>
                                            ④最終確認
                                        </span>
                                    </div>
                                </div>
                                <div className={`swiper-slide `}>
                                    <div className="status right-border-off">
                                        <span className={`timeline-text `}>
                                            ⑥完了
                                        </span>
                                    </div>
                                </div>
                                {/* <div className={`swiper-slide ${status === 2 ? "half-red" : status > 2 ? "active" : ''}`}>
                                    <div className={`status ${status === 2 ? "right-border-ass" : ''}`}>
                                        <span className={`timeline-text ${status > 1 ? "text-red-06" : ''}`}>
                                            ③面談希望日の提出
                                        </span>
                                    </div>
                                </div>
                                <div className={`swiper-slide ${status === 3 ? "half-red" : status > 3 ? "active" : ''}`}>
                                    <div className={`status ${status === 3 ? "right-border-ass" : ''}`}>
                                        <span className={`timeline-text ${status > 2 ? "text-red-06" : ''}`}>
                                            ④最終確認
                                        </span>
                                    </div>
                                </div>
                                <div className={`swiper-slide ${status === 4 ? "half-red" : status > 4 ? "active" : ''}`}>
                                    <div className="status right-border-off">
                                        <span className={`timeline-text ${status > 3 ? "text-red-06" : ''}`}>
                                            ⑥完了
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* TODO: Look at PHP code */}
            {/* <BidUpload /> */}

            {
                status == 3 ?

                    <div>
                        <div className="speech-bubble speech-bubble-top py-5 px-lg-5 px-4 mb-5">
                            <div className="text-center text-sm py-1 fw-300 mb-4">
                                <Image className="height-25 mb-1 me-2" src="assets/images/other/icon-page-fold.svg" />面談希望日時を提出してください
                            </div>
                            <div className="row mb-5 text-left">
                                <div className="col-lg-9 col-md-10 mx-auto">
                                    <div className="row form-theme">
                                        <div className="col-lg-4 mb-3">
                                            <Form.Label>希望日</Form.Label>
                                            <div className="date-time mb-2">
                                                <Form.Control type="text" className="datepicker" placeholder="第一希望日を選択" />
                                                <span>
                                                    <Image className="height-25" src="assets/images/other/icon-calendar-ass.svg" />
                                                </span>
                                            </div>
                                            <div className="date-time mb-2">
                                                <Form.Control type="text" className="datepicker" placeholder="第二希望日を選択" />
                                                <span>
                                                    <Image className="height-25" src="assets/images/other/icon-calendar-ass.svg" />
                                                </span>
                                            </div>
                                            <div className="date-time mb-2">
                                                <Form.Control type="text" className="datepicker" placeholder="第三希望日を選択" />
                                                <span>
                                                    <Image className="height-25" src="assets/images/other/icon-calendar-ass.svg" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 mb-3">
                                            <label>希望時間</label>
                                            <div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）14：00" />
                                                </div>
                                                <div className="d-inline-block align-middle"> ～ </div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）18：00" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）14：00" />
                                                </div>
                                                <div className="d-inline-block align-middle"> ～ </div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）18：00" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）14：00" />
                                                </div>
                                                <div className="d-inline-block align-middle"> ～ </div>
                                                <div className="d-inline-block border mb-2 text-ass-09 w-max-130 w-min-130 align-middle">
                                                    <Form.Control type="text" className="form-control border-0 focus-off" placeholder="例）18：00" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-3">
                                            <label>希望する面談方法</label>
                                            <hr className="mt-0 mb-3" />
                                            <div>
                                                <Form.Group className="form-check form-check-inline">
                                                    <Form.Control className="form-check-input childCheckBox" id="checkbox1" type="checkbox" name="" value="1" />
                                                    <Form.Label className="form-check-label" for="checkbox1">訪問</Form.Label>
                                                </Form.Group>
                                                <Form.Group className="form-check form-check-inline">
                                                    <Form.Control className="form-check-input childCheckBox" id="checkbox2" type="checkbox" name="" value="1" />
                                                    <Form.Label className="form-check-label" for="checkbox2">web</Form.Label>
                                                </Form.Group>
                                                <Form.Group className="form-check form-check-inline">
                                                    <Form.Control className="form-check-input childCheckBox" id="checkbox3" type="checkbox" name="" value="1" />
                                                    <Form.Label className="form-check-label" for="checkbox3">電話</Form.Label>
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center py-1 fw-300 mb-4">
                                <Image className="height-25 mb-1 me-2" src="assets/images/other/icon-list-clip-art-02.svg" />申込書をアップロード
                            </div>
                            <div className="row mb-4 text-center">
                                <div className="col-lg-9 col-md-10 mx-auto">
                                    <div className="border-dashed rounded-12 p-lg-5 p-4 mb-3 text-sm text-ass-07 fw-300">
                                        ここに見積書データをドラッグ＆ドロップ<br />
                                        または対象のデータを選択
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <Button className="btn-theme btn-primary rounded-pill px-lg-5 px-3 me-2">データを選択</Button>
                                <Button className="btn-theme btn-danger rounded-pill px-lg-5 px-3"><span className="px-lg-4 px-3">送信する</span></Button>
                            </div>
                        </div>
                    </div>
                    : ''}

            {/* TODO: Look at PHP Code */}

            {
                status == 4 ?


                    <div>
                        <div className="speech-bubble speech-bubble-top py-5 px-lg-5 px-4">
                            <div className="text-center text-sm py-1 fw-300 mb-4">
                                <Image className="height-25 mb-1 me-2" src="assets/images/other/icon-users-like.svg" /> 最終確認を完了してください
                            </div>
                            <div className="text-center">
                                <a href="#" type="button" className="btn btn-theme btn-danger rounded-pill px-lg-5 px-3">契約手続きを完了しました</a>
                            </div>
                        </div>
                    </div>

                    : ''}
        </>
    )
}

export default BidProgress;